import { activityConstants } from '../constants/activity.constants';

export function activity(state = {}, action) {
  switch (action.type) {
    case activityConstants.FETCH_REQUEST:
      return {
        ...state,
        loading: true
      };

    case activityConstants.FETCH_SUCCESS:
      return {
        ...state,
        list: action.activity,
        loading: false
      };

    case activityConstants.FETCH_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };

    default:
      return state
  }
}
